import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Docs() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);



	return (


		<>
			<Helmet>
				<title>Organize and Store Employee Documentation management with Taskflier.</title>
			</Helmet>
				<div class="block-style-thirtySix bg-white lg-container pt-110 pb-50 border-bottom " id="feature">
					<div class="container">
						<div class="row">
							<div class="col-xl-6 col-lg-7  aos-init aos-animate" data-aos="fade-left">
								<div class="pl-lg-5">
									<div class="title-style-fourteen">
										<h6><span class="upper-title custom-name">Employee Documentation</span></h6>
										<h1>Centralized Employee Documentation for Organized Workflows</h1>
									</div>
									<div class="tag-line">Maintaining employee information, records, and records is essential to successful operations. TaskFlier's employee documents feature helps you store, manage, and access all your employee documents in one secure, organized place. Simplify HR processes and maintain regulatory compliance by maintaining important documents with just one click.</div>

								</div>
							</div>
							<div class="col-xl-6 col-lg-5 text-center text-lg-left  aos-init aos-animate" data-aos="fade-right">
								<div class="illustration-holder d-inline-block md-mt-60">
									<img src="/main/images/dashboard.png" alt="" class="w-100" />
									<img src="/images/assets/ils_23.1.svg" alt="" class="shapes shape-one" />
									<img src="/images/assets/ils_23.2.svg" alt="" class="shapes shape-two" />
									<img src="/images/assets/ils_23.3.svg" alt="" class="shapes shape-three" />
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="fancy-feature-sixteen pt-80 pb-120  md-mt-100 bg-white" id="feature">
					<div class="container">
						<div class="block-style-eighteen">
							<div class="row align-items-center">
								<div class="col-lg-5 aos-init aos-animate" data-aos="fade-right" data-aos-duration="1200">
									<div class="text-wrapper">

										<h3 class="title">About TaskFlier

											<span>professional records</span></h3>
										<p>TaskFlier's employee document feature brings together important information, reduces paperwork, and ensures your organization's documents are safe and easily accessible. From onboarding to performance monitoring, TaskFlier helps you keep records that improve HR efficiency and support employee development.

										</p>

									</div>
								</div>
								<div class="col-lg-7 aos-init aos-animate" data-aos="fade-left" data-aos-duration="1200">
									<div class="screen-holder-three d-flex align-items-center justify-content-center">
										<img src="/images/assets/screen_14.png" alt="" />
									</div>
								</div>
							</div>
						</div>


					</div>
				</div>



				<div class="fancy-feature-thirtyOne pt-80 pb-100  bg-orange">
					<div class="container">

						<div class="row fixedbox">
							<div class="col-md-4 aos-init" data-aos="fade-up">
								<div class="block-style-thirtyTwo d-block px-4 pt-4">
									<img src="/images/assets/screen_39.png" alt='' className='w-100 mb-3' />
									<div class="text p-0">

										<h4>Secure record keeping



										</h4>
										<p>Keep employee records, certificates, contracts, and other documents in a secure, locked location. Retrieve documents quickly without worrying about lost files or unauthorized access. Keep information confidential and safe.

										</p>

									</div>
								</div>
							</div>
							<div class="col-md-4 aos-init" data-aos="fade-up">
								<div class="block-style-thirtyTwo d-block px-4 pt-4">
									<img src="/images/assets/screen_39.png" className='w-100 mb-3' />
									<div class="text p-0">

										<h4>Types of documents that can be edited



										</h4>
										<p>Organize files with customizable categories like Onboarding, Training, Performance, and more for easy access. Categorize documents by employee, department, or project, creating a systematic and organized document repository.

										</p>

									</div>
								</div>
							</div>
							<div class="col-md-4 aos-init" data-aos="fade-up">
								<div class="block-style-thirtyTwo d-block px-4 pt-4">
									<img src="/images/assets/screen_39.png" className='w-100 mb-3' />
									<div class="text p-0">

										<h4>Efficient document uploading and retrieval


										</h4>
										<p> Quickly upload, archive, and retrieve documents with just a few clicks. Makes it easy to keep track of record keeping. Supports multiple file types (PDF, Word, images, etc.) to support a wide range of document formats.
										</p>

									</div>
								</div>
							</div>
							<div class="col-md-4 aos-init" data-aos="fade-up">
								<div class="block-style-thirtyTwo d-block px-4 pt-4">
									<img src="/images/assets/screen_39.png" className='w-100 mb-3' />
									<div class="text p-0">

										<h4>Access control and permissions </h4>
										<p>Access level control only authorized personnel are allowed to view or edit sensitive information. Set permissions according to role and ensure that only relevant stakeholders have access to each document.



										</p>

									</div>
								</div>
							</div>
							<div class="col-md-4 aos-init" data-aos="fade-up">
								<div class="block-style-thirtyTwo d-block px-4 pt-4">
									<img src="/images/assets/screen_39.png" className='w-100 mb-3' />
									<div class="text p-0">

										<h4>Digital Signature Integration

										</h4>
										<p>Relationship between signals View digital signatures on important documents directly in TaskFlier, making the approval process easier. Reduce paperwork and simplify signature verification for contracts. Policy Agreement and compliance documentation.
										</p>

									</div>
								</div>
							</div>
							<div class="col-md-4 aos-init" data-aos="fade-up">
								<div class="block-style-thirtyTwo d-block px-4 pt-4">
									<img src="/images/assets/screen_39.png" className='w-100 mb-3' />
									<div class="text p-0">

										<h4>General user information

										</h4>
										<p> Keep complete employee profiles with documents. Personal information, job roles, and work history in one place. Provides HR visibility and supports effective talent management by maintaining multiple records for each team member.



										</p>

									</div>
								</div>
							</div>




						</div>
					</div>
				</div>
				<div class="fancy-feature-thirtySeven bg-white lg-container pt-100 " id="stories">
					<div class="block-style-fortyOne">
						<div class="container">
							<div class="row align-items-center">
								<div class="col-lg-5 aos-init aos-animate" data-aos="fade-right">
									<div class="title-style-eleven">

										<h2> Manage HR processes using TaskFlier employee records.

										</h2>
									</div>
									<p>
										TaskFlier's employee document feature simplifies document management. By centralizing employee records to increase safety, Easy and accessible, TaskFlier helps simplify the HR process. This makes it easier for you to focus on what matters: supporting and developing your team.
									</p>

								</div>
								<div class="col-xl-7 col-lg-6 ml-auto text-center text-lg-right aos-init aos-animate" data-aos="fade-left">
									<div class="img-holder md-mt-50 d-inline-block"><img src="/images/assets/screen_39.png" alt="" /></div>
								</div>
							</div>
						</div>
					</div>


				</div>
		</>

	)
}

export default Docs
